import { FC, Fragment } from 'react';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { appActions } from 'store/app/appSlice';
import { getGroupItem } from 'store/group/groupSelectors';
import { selectQuizFormSidebar } from 'store/app/appSelectors';
// Components
import Icon from 'components/Icon';
import { IconButton } from 'components/Buttons';
import { Loader } from 'components/Utilities';
import Menu from './Menu';
// MUI
import { useMediaQuery } from '@material-ui/core';
// Icons
import { FaTimes } from 'react-icons/fa';

const FormSidebar:FC = () => {
  const dispatch = useAppDispatch();

  const isSmallScreen = useMediaQuery('(max-width: 1023px)');

  const quizFormSidebar = useAppSelector(selectQuizFormSidebar);
  const groupItem = useAppSelector(getGroupItem);

  const handelToggleSidebar = () => {
    dispatch(appActions.toggleQuizFormSidebar());
  }

  if ( !groupItem ) return <Loader />;
  return (
    <Fragment>
      {quizFormSidebar ? (
        <div
          className="
            fixed top-0 left-0 w-full h-full z-40
            tablet:hidden
          "
          style={{ backgroundColor: 'rgba(0,0,0,0.68)'}}
          onClick={handelToggleSidebar}
        />
      ) : null}
      <div className="
        flex tablet:hidden
        items-center p-4
      ">
        <IconButton
          onClick={handelToggleSidebar}
          className="mr-2"
        ><Icon icon="menu" /></IconButton>
      </div>
      <div
        style={{ width: isSmallScreen ? '100%' : '25%' }}
        className={`
          max-h-full
          fixed tablet:relative
          left-0 tablet:left-auto
          bottom-0 tablet:bottom-auto
          transform tablet:translate-y-0
          tablet:flex-shrink-0 
          overflow-y-auto
          z-50 tablet:z-10
          ${quizFormSidebar ? 'translate-y-0' : 'translate-y-full'}
          flex flex-col
        `}
      >
        <div className="tablet:hidden">
          <div className="text-right p-4">
            <IconButton
              onClick={handelToggleSidebar}
            ><FaTimes /></IconButton>
          </div>
          <div className="divider my-0" />
        </div>
        <Menu />
      </div>
    </Fragment>
  )
}

export default FormSidebar;
